// extracted by mini-css-extract-plugin
export default {"author_admin":"AdminPage_author_admin__oE+CP","publicationsAdmin":"AdminPage_publicationsAdmin__6L1Wh"};